// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Col, Modal, Row, Space, Typography } from 'antd';
import { CheckCircleIcon } from '../Icons/CheckCircleIcon';
import { CheckOutlined } from '@ant-design/icons';

// Misc imports
import { t } from 'i18next';

const TranslationExportModal = ({
  isModalOpen = false,
  onClose = () => {},
  exportedEntities = []
}) => {

  return (
    <Modal
      open={isModalOpen}
      centered
      onCancel={onClose}
      title={null}
      footer={null}
    >
      <Row>
        <Col xs={24} className="text-center">
          <CheckCircleIcon className="text-success fs-xxxxl" />
        </Col>
        <Col xs={24} className="text-center my-3">
          <Typography.Text className="fw-500 fs-xl">
            {t('Flows Exported successfully!')}
          </Typography.Text>
        </Col>
        <Col xs={24} className="d-flex justify-content-center">
          <Space direction="vertical" className="w-60 ml-3">
            {exportedEntities.map(
              entity => <Typography.Text>
                <CheckOutlined className="text-success mr-2"/>
                {entity}
              </Typography.Text>
            )}
          </Space>
        </Col>
      </Row>
    </Modal>
  );
};

TranslationExportModal.propTypes = {
  isModalOpen: PropTypes.bool,
  exportedEntities: PropTypes.array,
  onClose: PropTypes.func
};

export default TranslationExportModal;
